import Vue from 'vue';
import { Checkbox } from 'element-ui';

/**
 * 此marco将指定的列渲染为图片,大小可以通过opt结构来指定
 */
interface opt {
    /**如果为number,那么单位为px,否则可自行指定单位 */
    size: number | string
}

export function macroImage(vm: Vue, h: any) {
    const scopedSlots = {
        default: function (body) {
            const desc = body.desc;

            let size;

            if (typeof desc.size === 'number') {
                size = desc.size + 'px';
            }
            else if (typeof desc.size === 'string') {
                size = desc.size;
            }
            else {
                return <span>{body.row[desc.prop]}</span>
            }

            return <img src={body.row[desc.prop]} style={`width:${size};height:${size};`} />
        },
    }

    return <colDefiner {...{ scopedSlots }}></colDefiner>;
}